<ion-app
  [ngClass]="{
    'ion-palette-dark': useDarkMode$$(),
    'theme-dark': useDarkMode$$(),
    'theme-light': !useDarkMode$$(),
    'app-offline': isOfflineBannerVisible$$(),
  }"
>
  <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>
  <app-toast-container />
  <app-consent-modal></app-consent-modal>
  <app-whats-new></app-whats-new>
</ion-app>
